module.exports = __webpack_public_path__ + "static/media/logo1.a1085b88.png";